import { useState } from 'react'
import { Button, Card, Flex, Grid, Typography } from 'antd'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { LoginsList } from '@/features/logins/LoginsList'
import { MY_LOGINS_WINDOW_DAYS } from '@/features/logins/loginsApi'
import { useMyLogins } from '@/features/logins/useMyLogins'

/** Jadval olti ustunli — undan kengroq ustunda qatorlar bo'shab qoladi */
const PAGE_MAX_WIDTH = 1160

/**
 * «Mening kirishlarim» — egasi talabi, 2026-08-20.
 *
 * > «Sessiyalarni ko'rsatishimiz kerak: qachon kirdi, qaysi qurilma
 * > qaysi IP dan. Status ham — rad etildi yoki muvaffaqiyatli,
 * > barchasini ko'rsatish kerak.»
 *
 * <h2>⚠️ FAQAT O'ZINIKI</h2>
 * `GET /api/auth/my-logins` odam identifikatorini TOKENDAN oladi va
 * `userId` parametrini umuman qabul qilmaydi (`AuthResource#myLogins`).
 * Ya'ni bu ekranda «kimning kirishlari» degan tanlov YO'Q va bo'lmaydi.
 *
 * <h2>⚠️ JAMI SONI KO'RSATILMAYDI</h2>
 * Javobda `total` yo'q, faqat `hasNext` (`MyLoginPage` javadoc'i:
 * manba cheksiz o'sadigan append-only jurnal). Shuning uchun bu yerda
 * `Pagination` ham, «Jami N ta» ham yo'q — ikkalasi ham YASALGAN son
 * bo'lardi. O'rniga «Oldingi / Keyingi» va sahifa raqami.
 *
 * <h2>⚠️ «Yana yuklash» EMAS, «Keyingi»</h2>
 * Ro'yxat almashadi, qo'shilmaydi. «Yana yuklash» deb yozish
 * `MyOperationsPage` da o'lchangan nuqsonni takrorlardi: tugma
 * yuklaydi deb va'da beradi, aslida esa ko'rinib turgan qatorlarni
 * ALMASHTIRADI va orqaga yo'l qoldirmaydi. Bu yerda orqaga yo'l bor.
 */
export function MyLoginsPage() {
  const { t } = useTranslation()
  const screens = Grid.useBreakpoint()
  const isMobile = screens.md === false
  const [page, setPage] = useState(0)
  const logins = useMyLogins(page)

  const hasNext = logins.page?.hasNext ?? false

  return (
    <div style={{ maxWidth: isMobile ? undefined : PAGE_MAX_WIDTH, margin: '0 auto' }}>
      {/* Sarlavha faqat kompyuterda — telefonda uni kabinetning yuqori
          qatori ko'rsatadi (`MyOperationsPage` bilan bir xil qaror). */}
      {isMobile ? null : (
        <div style={{ marginBottom: 16 }}>
          <Typography.Title level={4} style={{ margin: 0 }}>
            {t('myLogins.title')}
          </Typography.Title>
          <Typography.Text type="secondary">{t('myLogins.subtitle')}</Typography.Text>
        </div>
      )}

      <Card size="small" title={t('myLogins.listTitle')}>
        <Flex vertical gap={12}>
          {/* Ikki chegara OCHIQ aytiladi: davr serverda 90 kun bilan
              yopiladi va jami soni umuman hisoblanmaydi. Aytilmasa
              ikkalasi ham «eski kirishlarim yo'q ekan» bo'lib
              o'qilardi. */}
          <Typography.Text type="secondary" style={{ fontSize: 12 }}>
            {t('myLogins.window', { days: MY_LOGINS_WINDOW_DAYS })} {t('myLogins.noTotal')}
          </Typography.Text>

          <LoginsList state={logins} />

          {page > 0 || hasNext ? (
            <Flex gap={8} align="center" wrap>
              <Button
                icon={<LeftOutlined />}
                disabled={page === 0}
                onClick={() => setPage((p) => Math.max(0, p - 1))}
              >
                {t('myLogins.prev')}
              </Button>
              <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                {t('myLogins.pageLabel', { page: page + 1 })}
              </Typography.Text>
              <Button
                icon={<RightOutlined />}
                iconPosition="end"
                disabled={!hasNext}
                onClick={() => setPage((p) => p + 1)}
              >
                {t('myLogins.next')}
              </Button>
            </Flex>
          ) : null}
        </Flex>
      </Card>
    </div>
  )
}
